<app-stripe-payment-element
  [userProvidedEmail]="userProvidedEmail"
  [ngClass]="{ 'mb-4': addMargin$ | async }"
  data-cy="stripe-payment-element"
></app-stripe-payment-element>

<app-stripe-address-element
  (visible)="onAddressElementVisibleChange($event)"
  data-cy="stripe-address-element"
></app-stripe-address-element>
